// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchInput_wrapper__J3Uet","input":"SearchInput_input__7Nlnz","iconWrapper":"SearchInput_iconWrapper__q9eG2"};